import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { columns, writeAccessorKeys } from './constants'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import useQueryGetMemberGroup from '@/modules/manage-member/api/hooks/useQueryGetMemberGroup'
import {
	groupNameMapper,
	PermissionKeys,
} from '@/modules/manage-member/mappers'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { useMemo } from 'react'

interface ManageMemberTableProps {
	data: GetOperatorMemberListTableData[]
	total: number
	isLoading?: boolean
}

export default function ManageMemberTable({
	data,
	total,
	isLoading,
}: ManageMemberTableProps) {
	const payload = {
		take: 1000,
		skip: 0,
	}
	const { data: memberGroupData } = useQueryGetMemberGroup(payload)

	const groupTypeOptions =
		memberGroupData?.data?.map((item) => ({
			label: groupNameMapper[item.name] || item.name,
			value: item.id,
		})) || []

	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_OPERATOR,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSelector
					options={groupTypeOptions}
					placeholder="เลือกประเภท"
					label="ประเภทผู้ดูแลระบบ"
				/>

				<DataTableSearch placeHolder="ค้นหาชื่อผู้ดูแลระบบ" />
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
